function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailCapture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.2,288.08c7.17-59.18-27.56-135.61-63.56-166.08-65-55-119-41-161-18s-48,93-77,126-64,84-20,124,98,9,144,4,107,13,140-7C395.68,337,407,314.24,410.2,288.08Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.2,288.08c7.17-59.18-27.56-135.61-63.56-166.08-65-55-119-41-161-18s-48,93-77,126-64,84-20,124,98,9,144,4,107,13,140-7C395.68,337,407,314.24,410.2,288.08Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.14,
    cy: 398.5,
    rx: 85.5,
    ry: 16.5,
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.14,
    cy: 398.5,
    rx: 85.5,
    ry: 16.5,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.08,261.73s-.54-2.9-.6-3.08c-.67-2.07-3.18-5.68-5.62-5.67a2.89,2.89,0,0,0-2.78,3.28c.18,1.71,1.72,3.17,3.11,4C325.82,261.26,330.08,261.73,330.08,261.73Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.8,242.2c-2.29.83-3.44,5.07-3.36,7.25,0,.19.44,3.11.48,3.09l0,0c-.18.67-.37,1.39-.57,2.18-.34,1.46-.72,3.12-1,4.94a49.47,49.47,0,0,0-.65,5.95,36.93,36.93,0,0,0,.22,6.68s0,.06,0,.08c-.3-.65-1.2-2.43-1.29-2.56-1.19-1.82-4.57-4.63-6.92-4A2.88,2.88,0,0,0,320,269.7c.62,1.6,2.49,2.6,4.06,3.05,1.76.5,5.69-.09,6-.14a52.28,52.28,0,0,0,1.45,6.66c.36,1.27.76,2.55,1.18,3.82-.27-.55-.53-1-.57-1.11-1.19-1.82-4.57-4.64-6.92-4a2.9,2.9,0,0,0-1.81,3.9c.62,1.6,2.49,2.6,4.06,3.05s4.94,0,5.83-.12c.17.49.33,1,.5,1.46.8,2.33,1.61,4.65,2.34,7,.26.81.48,1.62.71,2.43-.25-.49-.46-.9-.5-1-1.19-1.82-4.57-4.64-6.92-4a2.88,2.88,0,0,0-1.81,3.89c.62,1.61,2.49,2.61,4.06,3s4.62.06,5.67-.09c.21.83.42,1.67.58,2.49.1.56.23,1.09.3,1.66l.24,1.67c.11,1.06.23,2.16.31,3.2.06.73.1,1.42.15,2.11-.24-.81-.76-2.38-.82-2.51a11.22,11.22,0,0,0-3.73-4.24,3.36,3.36,0,0,0-.31-.56,2.88,2.88,0,0,0-4.24-.66c-1.85,1.59-1.39,6-.54,8,0,.12.74,1.34,1.18,2.1-.33-.41-.64-.81-1-1.23-.68-.82-1.38-1.63-2.13-2.5-.37-.41-.75-.83-1.14-1.24s-.82-.82-1.23-1.24c-1-.94-2-1.85-3.07-2.74.72-.59,3.27-2.74,4-4.2s1.25-3.51.49-5.05a2.89,2.89,0,0,0-4.09-1.3c-2.07,1.3-2.28,5.69-1.74,7.8,0,.13.59,1.6.91,2.4-.65-.53-1.29-1.06-1.95-1.58-1.93-1.49-3.93-2.94-5.91-4.39l-1.82-1.34c.26-.21,3.34-2.7,4.16-4.34.73-1.45,1.26-3.5.49-5a2.87,2.87,0,0,0-4.09-1.29c-2.07,1.29-2.27,5.68-1.74,7.79,0,.16.84,2.28,1.07,2.81-1.32-1-2.64-2-3.89-3a49.41,49.41,0,0,1-4.83-4.49c.12-.09,3.35-2.68,4.19-4.35.73-1.45,1.25-3.51.49-5.05a2.89,2.89,0,0,0-4.09-1.3c-2.07,1.3-2.28,5.69-1.74,7.8,0,.14.64,1.75.95,2.51l-.12.07a36.76,36.76,0,0,1-4-5.31c-.65-1-1.21-2.05-1.74-3.06.65-.42,3.6-2.37,4.52-3.79s1.63-3.35,1-5a2.88,2.88,0,0,0-3.92-1.74c-2.2,1.06-2.88,5.41-2.58,7.56,0,.12.31,1.29.54,2.14-.23-.45-.48-.92-.69-1.36-.8-1.66-1.43-3.23-2-4.63-.31-.79-.57-1.52-.81-2.2.43-.74,2.09-3.77,2.25-5.42s-.09-3.73-1.36-4.89a2.9,2.9,0,0,0-4.29.26c-1.45,2-.06,6.13,1.2,7.9.1.16,2.08,2.36,2.11,2.32l0,0c.22.66.45,1.36.73,2.13.52,1.41,1.12,3,1.89,4.68a51.77,51.77,0,0,0,2.73,5.31,37.67,37.67,0,0,0,3.88,5.45l.06.06c-.61-.37-2.35-1.36-2.49-1.42-2-.86-6.37-1.35-8,.49a2.88,2.88,0,0,0,.64,4.25c1.4,1,3.51.79,5.06.3,1.75-.55,4.7-3.21,4.94-3.43a50,50,0,0,0,4.88,4.76c1,.86,2,1.7,3.09,2.53l-1.09-.61c-2-.86-6.37-1.34-8,.5a2.87,2.87,0,0,0,.64,4.24c1.4,1,3.51.8,5.06.31s4.14-2.72,4.81-3.32l1.21.95c2,1.49,3.92,3,5.8,4.5.66.53,1.29,1.08,1.92,1.63-.47-.27-.88-.5-.94-.52-2-.86-6.37-1.35-8,.49a2.88,2.88,0,0,0,.63,4.24c1.41,1,3.52.8,5.07.31s3.88-2.5,4.68-3.21c.64.58,1.27,1.17,1.86,1.76.39.41.79.78,1.16,1.22l1.12,1.26c.68.83,1.39,1.68,2,2.5.45.57.87,1.12,1.29,1.68-.65-.54-1.95-1.57-2.07-1.65-1.84-1.15-6.09-2.29-7.95-.72a2.9,2.9,0,0,0,0,4.3c1.23,1.19,3.35,1.32,5,1.07,1.77-.28,5-2.36,5.36-2.63.7.92,1.37,1.83,2,2.69,2.16,3,3.84,5.54,5,7.34l.12.19,1.49-.73c-.08-.11-.15-.23-.24-.35-1.2-1.8-2.95-4.35-5.19-7.31-.71-.94-1.48-1.93-2.29-2.93a30.89,30.89,0,0,0,2.32-2.87,21.16,21.16,0,0,0,5.74.7c.07,1.15.14,2.27.18,3.33.15,3.68.14,6.74.1,8.88v.25l1.64-.79c0-2.13-.08-5-.3-8.41-.07-1.17-.17-2.42-.29-3.7.46-.12,4.17-1.07,5.57-2.19s2.6-2.66,2.56-4.38a2.89,2.89,0,0,0-3.18-2.89c-2.41.31-4.44,4.21-4.84,6.35,0,.13-.12,1.52-.17,2.41-.05-.53-.1-1-.15-1.57-.11-1.07-.25-2.13-.39-3.27l-.27-1.66c-.08-.56-.24-1.14-.35-1.71-.29-1.32-.66-2.65-1-4,.93-.1,4.24-.49,5.66-1.3s3-2.24,3.19-3.94a2.88,2.88,0,0,0-2.7-3.34c-2.44-.06-5,3.49-5.75,5.54,0,.13-.39,1.66-.57,2.51-.24-.8-.48-1.6-.75-2.4-.79-2.3-1.65-4.61-2.51-6.92-.26-.7-.51-1.41-.77-2.12.33,0,4.28-.41,5.86-1.32,1.41-.81,3-2.23,3.2-3.94a2.89,2.89,0,0,0-2.7-3.34c-2.44-.06-5,3.49-5.75,5.54-.06.16-.56,2.37-.66,2.93-.56-1.55-1.1-3.11-1.58-4.67a51.27,51.27,0,0,1-1.55-6.4c.16,0,4.27-.39,5.9-1.33,1.41-.81,3-2.23,3.19-3.94a2.88,2.88,0,0,0-2.7-3.34c-2.43-.06-5,3.49-5.75,5.55,0,.13-.42,1.81-.59,2.61h-.14a38.57,38.57,0,0,1-.37-6.62c0-1.21.12-2.38.24-3.51.77,0,4.31,0,5.86-.67s3.21-1.89,3.61-3.56a2.9,2.9,0,0,0-2.32-3.62c-2.41-.33-5.38,2.92-6.32,4.88-.05.11-.45,1.25-.73,2.09.06-.51.11-1,.18-1.52.25-1.83.59-3.49.9-4.95.18-.84.37-1.59.54-2.28.77-.39,3.82-2,4.87-3.29s2-3.16,1.56-4.83A2.89,2.89,0,0,0,334.8,242.2Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.73,279.78c1.91-.08,5.72-2,5.72-2s-2.05-2.11-2.2-2.23c-1.7-1.36-5.79-3-7.82-1.63a2.88,2.88,0,0,0-.5,4.26C287,279.47,289.11,279.84,290.73,279.78Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.08,261.73s-.54-2.9-.6-3.08c-.67-2.07-3.18-5.68-5.62-5.67a2.89,2.89,0,0,0-2.78,3.28c.18,1.71,1.72,3.17,3.11,4C325.82,261.26,330.08,261.73,330.08,261.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.8,242.2c-2.29.83-3.44,5.07-3.36,7.25,0,.19.44,3.11.48,3.09l0,0c-.18.67-.37,1.39-.57,2.18-.34,1.46-.72,3.12-1,4.94a49.47,49.47,0,0,0-.65,5.95,36.93,36.93,0,0,0,.22,6.68s0,.06,0,.08c-.3-.65-1.2-2.43-1.29-2.56-1.19-1.82-4.57-4.63-6.92-4A2.88,2.88,0,0,0,320,269.7c.62,1.6,2.49,2.6,4.06,3.05,1.76.5,5.69-.09,6-.14a52.28,52.28,0,0,0,1.45,6.66c.36,1.27.76,2.55,1.18,3.82-.27-.55-.53-1-.57-1.11-1.19-1.82-4.57-4.64-6.92-4a2.9,2.9,0,0,0-1.81,3.9c.62,1.6,2.49,2.6,4.06,3.05s4.94,0,5.83-.12c.17.49.33,1,.5,1.46.8,2.33,1.61,4.65,2.34,7,.26.81.48,1.62.71,2.43-.25-.49-.46-.9-.5-1-1.19-1.82-4.57-4.64-6.92-4a2.88,2.88,0,0,0-1.81,3.89c.62,1.61,2.49,2.61,4.06,3s4.62.06,5.67-.09c.21.83.42,1.67.58,2.49.1.56.23,1.09.3,1.66l.24,1.67c.11,1.06.23,2.16.31,3.2.06.73.1,1.42.15,2.11-.24-.81-.76-2.38-.82-2.51a11.22,11.22,0,0,0-3.73-4.24,3.36,3.36,0,0,0-.31-.56,2.88,2.88,0,0,0-4.24-.66c-1.85,1.59-1.39,6-.54,8,0,.12.74,1.34,1.18,2.1-.33-.41-.64-.81-1-1.23-.68-.82-1.38-1.63-2.13-2.5-.37-.41-.75-.83-1.14-1.24s-.82-.82-1.23-1.24c-1-.94-2-1.85-3.07-2.74.72-.59,3.27-2.74,4-4.2s1.25-3.51.49-5.05a2.89,2.89,0,0,0-4.09-1.3c-2.07,1.3-2.28,5.69-1.74,7.8,0,.13.59,1.6.91,2.4-.65-.53-1.29-1.06-1.95-1.58-1.93-1.49-3.93-2.94-5.91-4.39l-1.82-1.34c.26-.21,3.34-2.7,4.16-4.34.73-1.45,1.26-3.5.49-5a2.87,2.87,0,0,0-4.09-1.29c-2.07,1.29-2.27,5.68-1.74,7.79,0,.16.84,2.28,1.07,2.81-1.32-1-2.64-2-3.89-3a49.41,49.41,0,0,1-4.83-4.49c.12-.09,3.35-2.68,4.19-4.35.73-1.45,1.25-3.51.49-5.05a2.89,2.89,0,0,0-4.09-1.3c-2.07,1.3-2.28,5.69-1.74,7.8,0,.14.64,1.75.95,2.51l-.12.07a36.76,36.76,0,0,1-4-5.31c-.65-1-1.21-2.05-1.74-3.06.65-.42,3.6-2.37,4.52-3.79s1.63-3.35,1-5a2.88,2.88,0,0,0-3.92-1.74c-2.2,1.06-2.88,5.41-2.58,7.56,0,.12.31,1.29.54,2.14-.23-.45-.48-.92-.69-1.36-.8-1.66-1.43-3.23-2-4.63-.31-.79-.57-1.52-.81-2.2.43-.74,2.09-3.77,2.25-5.42s-.09-3.73-1.36-4.89a2.9,2.9,0,0,0-4.29.26c-1.45,2-.06,6.13,1.2,7.9.1.16,2.08,2.36,2.11,2.32l0,0c.22.66.45,1.36.73,2.13.52,1.41,1.12,3,1.89,4.68a51.77,51.77,0,0,0,2.73,5.31,37.67,37.67,0,0,0,3.88,5.45l.06.06c-.61-.37-2.35-1.36-2.49-1.42-2-.86-6.37-1.35-8,.49a2.88,2.88,0,0,0,.64,4.25c1.4,1,3.51.79,5.06.3,1.75-.55,4.7-3.21,4.94-3.43a50,50,0,0,0,4.88,4.76c1,.86,2,1.7,3.09,2.53l-1.09-.61c-2-.86-6.37-1.34-8,.5a2.87,2.87,0,0,0,.64,4.24c1.4,1,3.51.8,5.06.31s4.14-2.72,4.81-3.32l1.21.95c2,1.49,3.92,3,5.8,4.5.66.53,1.29,1.08,1.92,1.63-.47-.27-.88-.5-.94-.52-2-.86-6.37-1.35-8,.49a2.88,2.88,0,0,0,.63,4.24c1.41,1,3.52.8,5.07.31s3.88-2.5,4.68-3.21c.64.58,1.27,1.17,1.86,1.76.39.41.79.78,1.16,1.22l1.12,1.26c.68.83,1.39,1.68,2,2.5.45.57.87,1.12,1.29,1.68-.65-.54-1.95-1.57-2.07-1.65-1.84-1.15-6.09-2.29-7.95-.72a2.9,2.9,0,0,0,0,4.3c1.23,1.19,3.35,1.32,5,1.07,1.77-.28,5-2.36,5.36-2.63.7.92,1.37,1.83,2,2.69,2.16,3,3.84,5.54,5,7.34l.12.19,1.49-.73c-.08-.11-.15-.23-.24-.35-1.2-1.8-2.95-4.35-5.19-7.31-.71-.94-1.48-1.93-2.29-2.93a30.89,30.89,0,0,0,2.32-2.87,21.16,21.16,0,0,0,5.74.7c.07,1.15.14,2.27.18,3.33.15,3.68.14,6.74.1,8.88v.25l1.64-.79c0-2.13-.08-5-.3-8.41-.07-1.17-.17-2.42-.29-3.7.46-.12,4.17-1.07,5.57-2.19s2.6-2.66,2.56-4.38a2.89,2.89,0,0,0-3.18-2.89c-2.41.31-4.44,4.21-4.84,6.35,0,.13-.12,1.52-.17,2.41-.05-.53-.1-1-.15-1.57-.11-1.07-.25-2.13-.39-3.27l-.27-1.66c-.08-.56-.24-1.14-.35-1.71-.29-1.32-.66-2.65-1-4,.93-.1,4.24-.49,5.66-1.3s3-2.24,3.19-3.94a2.88,2.88,0,0,0-2.7-3.34c-2.44-.06-5,3.49-5.75,5.54,0,.13-.39,1.66-.57,2.51-.24-.8-.48-1.6-.75-2.4-.79-2.3-1.65-4.61-2.51-6.92-.26-.7-.51-1.41-.77-2.12.33,0,4.28-.41,5.86-1.32,1.41-.81,3-2.23,3.2-3.94a2.89,2.89,0,0,0-2.7-3.34c-2.44-.06-5,3.49-5.75,5.54-.06.16-.56,2.37-.66,2.93-.56-1.55-1.1-3.11-1.58-4.67a51.27,51.27,0,0,1-1.55-6.4c.16,0,4.27-.39,5.9-1.33,1.41-.81,3-2.23,3.19-3.94a2.88,2.88,0,0,0-2.7-3.34c-2.43-.06-5,3.49-5.75,5.55,0,.13-.42,1.81-.59,2.61h-.14a38.57,38.57,0,0,1-.37-6.62c0-1.21.12-2.38.24-3.51.77,0,4.31,0,5.86-.67s3.21-1.89,3.61-3.56a2.9,2.9,0,0,0-2.32-3.62c-2.41-.33-5.38,2.92-6.32,4.88-.05.11-.45,1.25-.73,2.09.06-.51.11-1,.18-1.52.25-1.83.59-3.49.9-4.95.18-.84.37-1.59.54-2.28.77-.39,3.82-2,4.87-3.29s2-3.16,1.56-4.83A2.89,2.89,0,0,0,334.8,242.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.73,279.78c1.91-.08,5.72-2,5.72-2s-2.05-2.11-2.2-2.23c-1.7-1.36-5.79-3-7.82-1.63a2.88,2.88,0,0,0-.5,4.26C287,279.47,289.11,279.84,290.73,279.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313,327.48s11.55-27.87,18-26.66-11.09,44.43-11.09,44.43,20.34-38.37,34.21-38.37-5.09,42.41-22.65,56.54c0,0,27.73-29.88,43.91-23.42S343,376.75,343,376.75s28.2-8.89,25-2-12,8.07-12,8.07l31.89,1.62H276.92l25-2.42S276,369.07,282.93,363.82s22.19,6.06,22.19,6.06-26.35-29.08-21.27-40,27.74,19.79,27.74,19.79-18.49-39.17-14.79-46S313,327.48,313,327.48Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,327.48s11.55-27.87,18-26.66-11.09,44.43-11.09,44.43,20.34-38.37,34.21-38.37-5.09,42.41-22.65,56.54c0,0,27.73-29.88,43.91-23.42S343,376.75,343,376.75s28.2-8.89,25-2-12,8.07-12,8.07l31.89,1.62H276.92l25-2.42S276,369.07,282.93,363.82s22.19,6.06,22.19,6.06-26.35-29.08-21.27-40,27.74,19.79,27.74,19.79-18.49-39.17-14.79-46S313,327.48,313,327.48Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.28,329c10.17,30,10.17,51.31,10.17,51.31s-12,.46-24.5-8.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.36,345.13a179.7,179.7,0,0,1,8.32-26.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.41,327.56l-25.89,38.37S301,351.14,295,342.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,375.17s27.28-12.94,38.37-20.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.05,271.18v17.33s2.77,26.43,7.25,51.83l-24.58,51.5,5.66.34s37.9-46.84,39.23-51.84-.89-42.83-.89-42.83l38.66,23.33,16.67,58.67,5.67-2.33s-5.78-62.83-7-64.34c-18.55-22.87-44.67-38-44.67-38l-5.33-9.66Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.38,
    y1: 298.37,
    x2: 166.81,
    y2: 285.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.04,
    y1: 295.72,
    x2: 170.78,
    y2: 282.92,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.61,215.91s-1.35,7.38.6,9.07,8.88,2.77,9.67-.59-5.73-36.7-6.52-40.06-3.15-1.38-3.94-.39S183.61,215.91,183.61,215.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.18,203.68s-21.68,8.74-28.38,11.72-3.14,9.67-2.14,12,17.08,44,17.48,44.75,3,2.56,6.72,2.55,25.44-5.39,26.22-8-.61-6.71-.61-6.71l-11.34-34.7s27.64,1.5,29,1.3,4.92-4.55.76-8.68-30.22-11.17-31.6-12.35S151.55,202.88,149.18,203.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.16,217.38l5.72,5.15,6.87,38.35,7.44,5.15,1.43-11.16-14-33.2v-6c0-1.43.57-4.87-3.15-6.58S132.58,209.94,137.16,217.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,211.56s-3.55,0-4.73,7.31.59,8.68,2.56,9.07,6.51,2,8.88-.39,2.57-7.7,1.19-11.84A6.27,6.27,0,0,0,183,211.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.38 203.87 150.26 214.92 144.15 211.56 141.97 217.29 141.38 203.87",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.96 197.95 141.78 218.08 133.29 209 131.32 196.57 142.96 197.95",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.13 203.67 140.31 213.08 137.73 221.38 128.36 210.58 130.13 203.67",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.49,265.87a68.35,68.35,0,0,1-38.34-11.6,61.12,61.12,0,0,1-26.75-41.41C151,178.45,176.24,145.81,212.74,140l33.75-6.47L250,158.62l-32.78,5.89-.36.07c-23,3.59-39,23.51-35.72,44.42s24.56,34.91,47.46,31.43L263,233.88l4.68,24.46L233,264.93l-.4.07A72.24,72.24,0,0,1,221.49,265.87Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.72,263.18a68.35,68.35,0,0,1-38.34-11.6,61.12,61.12,0,0,1-26.75-41.41c-5.42-34.41,19.84-67.06,56.34-72.86l33.75-6.47,3.46,25.09-32.78,5.89a2.25,2.25,0,0,1-.36.06c-23,3.59-39,23.52-35.71,44.43s24.55,34.91,47.46,31.43l34.48-6.55L267,255.65l-34.7,6.59-.4.07A72.24,72.24,0,0,1,220.72,263.18Z",
    style: {
      fill: "#2F55D4",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.44,260a65,65,0,0,1-31.38-10.88,60.55,60.55,0,0,1-16.13-15.89",
    style: {
      fill: "#2F55D4",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.84,260.1c-1,0-2.08.08-3.12.08",
    style: {
      fill: "#2F55D4",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.2,164.05a45.59,45.59,0,0,0-15.46,13.31,39.33,39.33,0,0,0-7.38,29.41c2,12.5,9.84,22.85,20.85,28.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.09,171.3a65.55,65.55,0,0,1,46.35-31l30.74-5.89,2.63,19.1-30.24,5.43a50.53,50.53,0,0,0-7.94,1.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.22,179.09q.9-2.19,2-4.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.22 160.6 249.18 155.93 245.72 130.84 219.35 135.9 223.22 160.6",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.95 255.65 262.27 231.19 235.07 236.35 238.92 260.97 266.95 255.65",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.87,254.34s36.45,2.1,38.25,1.8,7.44-6.33,8.86-7,4.28,1.41,6,2.09,3.17-.23,3.3,1.16-.89,1.93-2.86,1.83-3.15-.37-4.13-.42,2.06,2.09,4.7,4.6,4.76,3.41,4.11,4.56-2.22.87-3.17,0-3.7-1-5.87-1.1-5.83-1.88-5.83-1.88a143.7,143.7,0,0,1-15.36,2.75c-11.15,1.59-26.88,3.93-31.21,3.5s-7.18-6.3-7.18-6.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.8,215.4s-5.86,2.28-7.44,5.64.2,8.88,2.56,13.22,16.78,27,16.78,27l8.68-7.89s-7.89-24.86-8.88-27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,223.6a8.48,8.48,0,0,1,6.31,2.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.51,221.83s3,.59,4,7.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.41,246.89s-6.12,2.76-9.47,6.51-3,4.93-.79,7.3,3.55,3.55,4.93,2.57,10.66-7.11,11.25-8.69-1.38-7.49-2.76-8.09A4.2,4.2,0,0,0,139.41,246.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.36,184.33s6.12-5.72,6.91-8.49-1-7.1-1.58-7.3-1.18,1-1.18,2.57c0,0-1.78-2.17-2-.59a25.66,25.66,0,0,0-.19,2.76s-1.78-2-2.17-.59a2.42,2.42,0,0,0,.79,2.37s-2.57-2-2.57-.6a4.25,4.25,0,0,0,1.18,2.57s-3.35,4.54-3.15,6.91a2.29,2.29,0,0,0,2.17,2.36",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,175.06s1.38,1.38,1.18,2.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.34,173.28s1.58,2.17,1.58,3.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.51,171.11a8.57,8.57,0,0,1,1.58,4.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.38,392.18s8,7.66,10.34,10,5.33,3.66,3,3.66-7.34.67-12-.66-8.34-5.34-10-7.34,3-6,3-6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.82,404a30.9,30.9,0,0,1-12.62-1c-3.12-1-6.84-6-8.25-8-.59,1-.86,2-.23,2.79,1.66,2,5.33,6,10,7.34s9.66.66,12,.66C140.36,405.84,139.36,405.18,137.82,404Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.72,377.18s18,7.66,19.33,8,1.6,2.46-4.61,2.46c-2.67,0-12.73.66-15.06.66s-5,.21-5.66-1.12.33-7.67.33-7.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.05,385.18l-.05,0c-7.74,1.14-21.66.95-25.49.87a3.1,3.1,0,0,0,.21,1.15c.66,1.33,3.32,1.12,5.66,1.12s12.39-.66,15.06-.66C245.65,387.64,245.38,385.51,244.05,385.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.31 213.08 141.78 218.08 138.88 217.09 140.31 213.08",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.57,170.32s-1.19-3.55-6.12-3.95-13.82,6.71-14.61,11.65,6.52,18.15,8.69,20.12,20.52,1.39,21.11-1.18S146.51,177.82,142.57,170.32Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.17,182.36s2,2.56,3.16,2.76,3-.2,2,1-4.34,2-4.34,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,191.43s-4.34,1-6.31-2.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.44,
    y1: 188.47,
    x2: 135.66,
    y2: 190.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,184.33a6.11,6.11,0,0,1,2.56-1.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.69,181.17s1.18-1.77,4.93-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,178s-.2-3,2.57-2.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.88,180.73c.32.7.33,1.37,0,1.51s-.79-.33-1.11-1-.32-1.37,0-1.5S144.57,180,144.88,180.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.78,189.66s3-.79,3-2.37-1.19-2-.79-3.16,3.16-2.76,2.37-4.54-4.74-1.77-4.34-3.15,13.61-4.74,14.6-8.88-3.36-9.28-6.71-9.08-1.58,4.34-1.58,4.34-9.87-3-11.84.79,1.78,5.53,1.78,5.53-6.91,3.15-7.5,7.89,7.69,13.81,9.47,14.4S126.78,189.66,126.78,189.66Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,176.8s-5.66,3.91-6.44,7",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.34,178.75s-7,3.13-9.18,7.62",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.36,190.84s-1.19-2.76-3.36-2.56-1.58,3.35.59,5.92,4.74.79,4.94.2",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Emails--inject-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.44,
    y: 180.39,
    width: 26.94,
    height: 17.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "302.44 180.39 315.91 189.24 329.38 180.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.8,
    y: 141.4,
    width: 26.94,
    height: 17.71,
    transform: "translate(48.88 -87.41) rotate(14.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "360.42 138.33 371.27 150.25 386.52 145.01",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.47,
    y: 232.06,
    width: 26.94,
    height: 17.71,
    transform: "translate(70.9 -80.77) rotate(14.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "345.08 229 355.94 240.92 371.18 235.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.17,
    y: 171.48,
    width: 26.94,
    height: 17.71,
    transform: "translate(56.76 -89.79) rotate(14.36)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "373.79 168.41 384.64 180.33 399.89 175.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.47,
    y: 192.17,
    width: 26.94,
    height: 17.71,
    transform: "translate(283.98 -204.19) rotate(50.2)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "358.12 185 359.94 201.02 375.37 205.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.47,
    y: 128.17,
    width: 26.94,
    height: 17.71,
    transform: "translate(247.04 -253.35) rotate(50.2)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "392.12 121 393.94 137.02 409.37 141.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.8,
    y: 206.83,
    width: 26.94,
    height: 17.71,
    transform: "matrix(0.8, -0.59, 0.59, 0.8, -51.66, 274.23)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "375.18 216.55 391.27 215.69 396.87 200.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.19,
    y: 122.36,
    width: 26.94,
    height: 17.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "237.19 122.36 250.66 131.21 264.13 122.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.78,
    y: 124.29,
    width: 26.94,
    height: 17.71,
    transform: "translate(167.48 -152.41) rotate(43.6)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "270.6 117.44 274.25 133.14 290.11 136.02",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.54,
    y: 114.92,
    width: 26.94,
    height: 17.71,
    transform: "translate(-19.25 161.11) rotate(-25.12)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "336.06 121.47 352.01 123.77 360.45 110.04",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.1,
    y: 122.14,
    width: 26.94,
    height: 17.71,
    transform: "translate(513.95 -139.71) rotate(103.98)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "323.42 120.06 311.57 130.99 316.91 146.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.63,
    y: 224.42,
    width: 26.94,
    height: 17.71,
    transform: "translate(-88.08 185.85) rotate(-34.84)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "235.99 233.7 252.1 233.27 258.1 218.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.85,
    y: 227.79,
    width: 26.94,
    height: 17.71,
    transform: "matrix(0.82, -0.57, 0.57, 0.82, -84.05, 205.43)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "269.21 237.07 285.32 236.64 291.32 221.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.44,
    y: 139.47,
    width: 26.94,
    height: 17.71,
    transform: "translate(95.5 -98.26) rotate(27.19)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "242.98 134.29 250.92 148.32 266.94 146.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.04,
    y: 242.01,
    width: 26.94,
    height: 17.71,
    transform: "translate(143.53 -91.77) rotate(27.19)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "253.57 236.83 261.51 250.87 277.54 249.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCapture);
export default __webpack_public_path__ + "static/media/email-capture.5a9706fa67d4048c2f9a1855f2f3cc66.svg";
export { ForwardRef as ReactComponent };